
import * as Yup from 'yup';
import ValidationMessage from '../../constants/Validation/ValidationMessage';
import ValidationMessageAlbanian from '../../constants/Validation/ValidationMessageChange';


const emojiFreeRegex = /^[^\uD800-\uDBFF\uDFFF\u2600-\u26FF\u2700-\u27BF]+$/; // Example regex to exclude emojis
const local_language = localStorage.getItem('lang')

const ProfileDetailValidation = Yup.object().shape(
    {

        ownerName: Yup.string().required(local_language == "alb" ? 'Ju lutemi shkruani emrin e pronarit' : 'Please enter owner name')
            .min(3, local_language == "alb" ? ValidationMessageAlbanian.MinLength('Emri i pronarit', 3) : ValidationMessage?.MinLength("owner name ", 3))
            .max(25, local_language == "alb" ? ValidationMessageAlbanian.MaxLength('Emri i pronarit', 25) : ValidationMessage?.MaxLength("owner name", 25))
            .matches(emojiFreeRegex, (local_language == "alb" ? "Emoji nuk lejohen" : "Emojis not allowed")),

        experience: Yup.string()
            .required(local_language == "alb" ? 'Ju lutemi shkruani përvojën tuaj' : 'Please enter your experience')
            .matches(/^(0\.[1-9]|[1-9][0-9]?(\.[0-9])?)$/, {
                message: local_language == "alb" ? 'Ju lutemi shkruani përvojën e saktë. Shembuj: 0.2 vjet, 2 vjet, 20 vjet' : 'Please enter correct experience.Examples: 0.2 years, 2 years, 20 years',
            })
            .test('max', local_language == "alb" ? 'Eksperienca nuk mund të jetë më e madhe se 20 vjet.' : 'Experience cannot be greater than 20 years.', (value) => {
                const experience = parseFloat(value);
                return experience <= 20;
            }),

        // inputs: Yup.object().shape({
        //     input1: Yup.string().required('This field is required'),
        //     input2: Yup.string().required('This field is required'),
        //     input3: Yup.string().required('This field is required')
        // }),
        // calendar: Yup.array()
        //     .of(calendarItemSchema)
        //     .test('atLeastOneDay', 'At least one operational day must be selected', (calendar) =>
        //         Array.isArray(calendar) && calendar.some(day => !day.dayOff)
        //     )
        //     .required('Calendar is required')
    });

export default ProfileDetailValidation;
